import { render, staticRenderFns } from "./SpcModelManager.vue?vue&type=template&id=61965f5a&"
import script from "./SpcModelManager.js?vue&type=script&lang=js&"
export * from "./SpcModelManager.js?vue&type=script&lang=js&"
import style0 from "./SpcModelManager.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports